import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import DisguisedBlock from "./disguised-block";
import {intrinsicBlocksMap} from '../white-list/white-list'

const SelectedDisguisedBlock = props => {
    const searchedBlockInfo = useMemo(() => {
        const intrinsicBlockKeys = Object.keys(intrinsicBlocksMap);
        for (let i = 0; i < intrinsicBlockKeys.length; i++) {
            const intrinsicBlockKey = intrinsicBlockKeys[i];
            const blockCategoryList = intrinsicBlocksMap[intrinsicBlockKey]
            for (let j = 0; j < blockCategoryList.length; j++) {
                const blockCategoryListElement = blockCategoryList[j];
                if (blockCategoryListElement.opcode === props.value) {
                    return blockCategoryListElement
                }
            }
        }
        return null;
    }, [props.value])
    return <img src={searchedBlockInfo.img} alt='pic' />
}

DisguisedBlock.propTypes = {
    value: PropTypes.string.isRequired,
};

export default SelectedDisguisedBlock;
